var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 0.666748H1.66665C0.933313 0.666748 0.33998 1.26675 0.33998 2.00008L0.333313 10.0001C0.333313 10.7334 0.933313 11.3334 1.66665 11.3334H12.3333C13.0666 11.3334 13.6666 10.7334 13.6666 10.0001V2.00008C13.6666 1.26675 13.0666 0.666748 12.3333 0.666748ZM12.3333 3.33341L6.99998 6.66675L1.66665 3.33341V2.00008L6.99998 5.33341L12.3333 2.00008V3.33341Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailLogin);
export default __webpack_public_path__ + "static/media/mail-login.1cbdd4ffc94466a5b5e3fd9dfd3be046.svg";
export { ForwardRef as ReactComponent };